/**
 * TinyPivot Core - Type Definitions
 * Framework-agnostic types used across Vue and React packages
 */
/** Type guard to check if filter value is a numeric range */
export function isNumericRange(value) {
    if (value === null || typeof value !== 'object' || Array.isArray(value))
        return false;
    if (!('min' in value) && !('max' in value))
        return false;
    const v = value;
    return (v.min === null || typeof v.min === 'number') && (v.max === null || typeof v.max === 'number');
}
/** Type guard to check if filter value is a date range */
export function isDateRange(value) {
    if (value === null || typeof value !== 'object' || Array.isArray(value))
        return false;
    if (!('min' in value) && !('max' in value))
        return false;
    const v = value;
    return (v.min === null || typeof v.min === 'string') && (v.max === null || typeof v.max === 'string');
}
//# sourceMappingURL=index.js.map